const Data = [
 {
   "id": 1,
   "name": "Adelaide Crows",
   "imagename": "flag-adelaide.svg",
   "in": "Nil",
   "out": "Brad Crouch (StK), Rory Atkins (GC), Kyle Hartigan (Haw)",
   "picks": "1, 9, 22, 23, 40, 56, 66, 80",
   "desc": "Unsuccessfully tried to bluff their way to Pick 2 for Crouch, and ultimately deciding to not match will hurt from a perception standpoint. But Justin Reid’s decision to follow through on the threat to GWS that it was Pick 40 or the Crows would take Jackson Hately for nothing via the pre-season draft will help. Also had eyes on the Western Bulldogs’ Pick 14, which was traded to Collingwood.",
   "rated": 5.5,
   "fans": 0,
   "writer": "Simeon Thomas-Wilson"
 },
 {
   "id": 2,
   "name": "Brisbane Lions",
   "imagename": "flag-brisbane.svg",
   "in": "Joe Daniher (Ess), Nakia Cockatoo (Geel)",
   "out": "Alex Witherden (WCE), Stef Martin (WB)",
   "picks": "25, 53, 58, 63, 68, 69, 94",
   "desc": "Would have been even higher prior to the deal that sent Witherden to West Coast for not much given his age and ability. But if the Lions can get the injury-prone bodies of Daniher and Cockatoo right then this trade period could pay off in spades. Also got Melbourne’s first-round pick next year after trading down in this year’s draft in what could be a clever swap",
   "rated": 8,
   "fans": 0,
   "writer": "Simeon Thomas-Wilson"
 },
 {
   "id": 3,
   "name": "Carlton Blues",
   "imagename": "flag-carlton.svg",
   "in": "Zac Williams (GWS), Adam Saad (Ess), Lachie Fogarty (Gee)",
   "out": "Nil",
   "picks": "38, 48, 78",
   "desc": "There’s no excuses now. Carlton must play finals next year after an excellent trade period added some electric run and outside polish. The knock on Zac Williams was his fitness but a big summer can set him up for a move into the midfield. Adam Saad is reliable and former Cat Lachie Fogarty could easily play a full season as a hard-working forward-midfielder. Trade period mission accomplished",
   "rated": 8,
   "fans": 0,
   "writer": "Jay Clark"
 },
 {
   "id": 4,
   "name": "Collingwood Magpies",
   "imagename": "flag-collingwood.svg",
   "in": "Nil",
   "out": "Adam Treloar (WB), Jaidyn Stephenson (NM), Atu Bosenavulagi (NM), Tom Phillips (Haw)",
   "picks": "14, 16, 65, 70, 75, 92",
   "desc": "This trade period was a bitter pill to swallow for Pies’ fans, but it puts the club into a position to attack the free agency market next year. Rising Star winner Jaidyn Stephenson and Atu Bosenavulagi departed to North for peanuts, Adam Treloar was forced out to Western Bulldogs against his wishes and Tom Phillips went for Pick 65. While they all finished outside the top-10 of the best and fairest this year, there must be some other issues behind the scenes that have motivated Collingwood to cut them on the cheap.",
   "rated": 4,
   "fans": 0,
   "writer": "Jay Clark"
 },
 {
   "id": 5,
   "name": "Essendon Bombers",
   "imagename": "flag-essendon.svg",
   "in": "Jye Caldwell (GWS), Peter Wright (GC), Nick Hind (StK)",
   "out": "Orazio Fantasia (PA), Joe Daniher (Bris), Adam Saad (Car)",
   "picks": "6, 7, 8, 44, 67, 74, 85, 87",
   "desc": "Would be disappointed not to land Josh Dunkley, but in the end the Bombers didn’t want to part with two first-round picks for him. Best offer was Pick 7 and a future second-round choice but the Dogs’ list manager Sam Power was like Geoff Boycott in his strong defence. The Bombers have an outstanding draft hand and believe midfielder Jye Caldwell is a special talent. Peter Wright was a bargain and has the ability to kick 30+ goals and play an important role in the ruck.",
   "rated": 7,
   "fans": 0,
   "writer": "Jay Clark"
 },
 {
   "id": 6,
   "name": "Fremantle Dockers",
   "imagename": "flag-fremantle.svg",
   "in": "Nil",
   "out": "Jesse Hogan (GWS)",
   "picks": "12, 32, 55",
   "desc": "The Dockers wanted wayward key forward Hogan out and got their wish, offloading him to GWS and receiving a third-round pick back in return. It has been a costly mistake recruiting Hogan, who cost Fremantle a lot more — effectively Picks 6 and 23 — when it lured the West Australian back home from Melbourne at the end of 2018. The Dockers should land a handy player with their first draft pick as they continue to build an exciting young list.",
   "rated": 3,
   "fans": 0,
   "writer": "Chris Cavanagh"
 },
 {
   "id": 7,
   "name": "Geelong Cats",
   "imagename": "flag-geelong.svg",
   "in": "Jeremy Cameron (GWS), Shaun Higgins (NM), Isaac Smith (Haw)",
   "out": "Lachie Fogarty (Car), Nakia Cockatoo (Bris)",
   "picks": "51, 96 ",
   "desc": "Geelong gave up more than it wanted for Jeremy Cameron, and credit to GWS for driving a hard bargain, but Chris Scott has to be a happy man. The Cats will unleash two of the best key forwards in the competition next year with superstar Cameron saddling up alongside Tom Hawkins. Veterans Shaun Higgins and Isaac Smith add the lick of cream on the outside. And next year the Cats have one future first-round pick and three future second-round picks up their sleeve.",
   "rated": 7,
   "fans": 0,
   "writer": "Jay Clark"
 },
 {
   "id": 8,
   "name": "Gold Coast Suns",
   "imagename": "flag-goldcoast.svg",
   "in": "Rory Atkins (Adl), Oleg Markov (Rich)",
   "out": "Peter Wright (Ess)",
   "picks": "5, 27, 37, 76, 84",
   "desc": "Didn’t get the elite midfielder they wanted with Adam Treloar saying no thanks to a move. However the Suns did add some speed to the outside of their midfield through Atkins and Markov will help the defence as Stuart Dew’s side continues to grow. Only loss was Wright who didn’t play a game in 2020 so won’t bite the Suns like previous departures have.",
   "rated": 7,
   "fans": 0,
   "writer": "Simeon Thomas-Wilson"
 },
 {
   "id": 9,
   "name": "GWS Giants",
   "imagename": "flag-gws.svg",
   "in": "Jesse Hogan (Fre), Braydon Pruess (Melb)",
   "out": "Jeremy Cameron (Geel), Jye Caldwell (Ess), Zac Williams (Car), Aidan Corr (NM),  Zac Langdon (WCE)",
   "picks": "10, 13, 15, 20, 29, 52, 88",
   "desc": "Some quality players are walking out the door but the Giants have arguably salvaged this situation the best they could, getting Geelong to cave in on Cameron and pay three first-round selections in a draft first. Didn’t get the first-round pick they wanted for young-gun Caldwell though. Got Hogan in for unders, but while they needed a ruckman they have probably overpaid for Pruess.",
   "rated": 6.5,
   "fans": 0,
   "writer": "Simeon Thomas-Wilson"
 },
 {
   "id": 10,
   "name": "Hawthorn Hawks",
   "imagename": "flag-hawthorn.svg",
   "in": "Tom Phillips (Coll), Kyle Hartigan (Ade)",
   "out": "Isaac Smith (Geel)",
   "picks": "4, 24, 45, 46, 49, 72",
   "desc": "The Hawks said they were going to the draft this year and will do so with a fairly good hand. They picked up one of the steals of the trade period in Magpies wingman Phillips for a lowly Pick 65, who is a perfect replacement for departing veteran Smith. Key defender Hartigan came cheaply from the Crows and will help sure up a defence that lost James Frawley and Ben Stratton to retirement, as well as James Sicily to injury.",
   "rated": 8,
   "fans": 0,
   "writer": "Chris Cavanagh"
 },
 {
   "id": 11,
   "name": "Melbourne Demons",
   "imagename": "flag-melbourne.svg",
   "in": "Ben Brown (NM)",
   "out": "Mitch Hannan (WB), Braydon Preuss (GWS)",
   "picks": "18, 19, 28, 50, 89",
   "desc": "Ben Brown was precisely what the Demons needed and to get it done for a bargain rate — given he has kicked 60 or more goals in three of the past four seasons — deserves credit. Disappointed to lose Mitch Hannan, but Braydon Preuss was always going to look for more opportunities.",
   "rated": 7.5,
   "fans": 0,
   "writer": "Glenn McFarlane"
 },
 {
   "id": 12,
   "name": "North Melbourne",
   "imagename": "flag-northmelbourne.svg",
   "in": "Aidan Corr (GWS), Jaidyn Stephenson (Coll), Lachie Young (WB), Atu Bosenavulagi (Coll)",
   "out": "Shaun Higgins (Geel), Ben Brown (Melb)",
   "picks": "2, 11, 30, 39, 71, 81",
   "desc": "Out of what looked like the ashes, the Kangaroos have emerged with a clear eye on the future. Shaun Higgins and Ben Brown are big losses. But the Kangaroos are looking to the draft for renewal with Picks 2 and 11. The ability to snare Jaidyn Stephenson on the last day also provides a big upside if they can get him back to that 2018 form again. Aidan Corr is ready to go, Lachie Young will add something to defence, and Atu Bosenavulagi is worth the gamble. The new coach, whoever he is, will have some young talent to work with.",
   "rated": 5.5,
   "fans": 0,
   "writer": "Glenn McFarlane"
 },
 {
   "id": 13,
   "name": "Port Adelaide Power",
   "imagename": "flag-portadelaide.svg",
   "in": "Aliir Aliir (Syd), Orazio Fantasia (Ess)",
   "out": "Nil",
   "picks": "35, 47, 57, 59, 73, 95",
   "desc": "Fantasia is finally a Port Adelaide player and the Power did not have to give up a lot to secure the livewire forward. If fit, the former Bomber can definitely add something to the Power’s attack and allow Connor Rozee and Zak Butters to play more midfield. Also secured Aliir, who could address the lack of height in the Power’s defence, for just a second-round pick.",
   "rated": 8,
   "fans": 0,
   "writer": "Simeon Thomas-Wilson"
 },
 {
   "id": 14,
   "name": "Richmond Tigers",
   "imagename": "flag-richmond.svg",
   "in": "Nil",
   "out": "Jack Higgins (StK), Oleg Markov (GC)",
   "picks": "17, 36, 61, 79, 97",
   "desc": "When you’ve won back-to-back premierships and have your whole premiership team already locked away for 2021, you can afford to take it easy during the trade period. Richmond moved four spots up order in the first round of the draft and picked up future second-round and third-round picks in exchange for offloading Higgins and Markov. Higgins found himself down the pecking order of small forwards this year, while Markov was an emergency in the Grand Final but never really hit his straps in five years at Punt Rd.",
   "rated": 4,
   "fans": 0,
   "writer": "Chris Cavanagh"
 },
 {
   "id": 15,
   "name": "St Kilda Saints",
   "imagename": "flag-stkilda.svg",
   "in": "Brad Crouch (Adel), Shaun McKernan (Ess), Jack Higgins (Rich)",
   "out": "Nick Hind (Ess)",
   "picks": "21, 64, 67, 74, 93",
   "desc": "For the second year in a row, the Saints have had some serious trade/free agency wins without losing much in the other direction. Brad Crouch and Jack Higgins should be Round 1 locks next year, while Shaun McKernan would back himself to win a forward slot. Only Higgins cost the Saints, and that was a sliding back of trade positions with the Tigers, which still gives them Pick 21. Great result.",
   "rated": 9,
   "fans": 0,
   "writer": "Glenn McFarlane"
 },
 {
   "id": 16,
   "name": "Sydney Swans",
   "imagename": "flag-sydney.svg",
   "in": "Tom Hickey (WCE)",
   "out": "Aliir Aliir (PA)",
   "picks": "3, 31, 34, 43, 60, 82",
   "desc": "Another modest trade period for the Swans as the club looks to claim a marquee player with its first round selection. John Longmire was desperate for a ruckman and the Swans were able to bring in Tom Hickey to his fourth club. But the loss of key defender Aliir Aliir to Port Adelaide stings.",
   "rated": 5,
   "fans": 0,
   "writer": "Glenn McFarlane"
 },
 {
   "id": 17,
   "name": "West Coast Eagles",
   "imagename": "flag-westcoast.svg",
   "in": "Zac Langdon (GWS), Alex Witherden (Bris)",
   "out": "Tom Hickey (Syd)",
   "picks": "62, 86, 91",
   "desc": "The Eagles won’t have any top young talent coming in through the draft, but have picked up a pair of promising young players in Langdon and Witherden. Langdon is a 24-year-old small forward originally from Western Australia, while Witherden fell out of favour at the Lions this year but is a capable 22-year-old rebounding defender with good foot skills. An abundance of talls meant the Eagles could afford to let ruckman Hickey go in a deal that improves their 2021 draft hand.",
   "rated": 7,
   "fans": 0,
   "writer": "Chris Cavanagh"
 },
 {
   "id": 18,
   "name": "Western Bulldogs",
   "imagename": "flag-westernbulldogs.svg",
   "in": "Adam Treloar (Coll), Stefan Martin (Bris), Mitch Hannan (Melb)",
   "out": "Lachie Young (NM)",
   "picks": "26, 33, 41, 42, 54, 90",
   "desc": "Hit the jackpot. An already stacked midfield is set to get stronger, with Treloar finding his way to Whitten Oval cheaply and Josh Dunkley staying put. Young ruckman Tim English was crying out for help and he’s finally got it in the form of journeyman Martin. The former Lion turns 34 next week but is feeling good and hopes to play every game next year alongside English. Martin effectively came in exchange for wingman Young, who had played just two AFL games this year. Hannan is a likely type in the forward half and should prove a handy pick-up. ",
   "rated": 10,
   "fans": 0,
   "writer": "Chris Cavanagh"
 }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js